import React from 'react';

import MetaTags from '#/components/layout/header/MetaTags';
import WalletDashboardContent from '#/components/wallet/dashboard/WalletDashboardContent';

import PositionsTableWrap from './PositionsTableWrap';

function PositionsPage() {
  return (
    <WalletDashboardContent title="Positions" showBalanceActions showStats>
      <MetaTags title="Positions" />

      <PositionsTableWrap />
    </WalletDashboardContent>
  );
}

export default PositionsPage;
